var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.categoryList.parent || _vm.categoryList.categories
    ? _c(
        "CategoryAsideBlock",
        { staticClass: "category-nav", attrs: { title: _vm.i18n("Category") } },
        [
          _c("nav", { staticClass: "category-nav__list" }, [
            _c(
              "div",
              { staticClass: "nav-aside" },
              [
                _vm.categoryList.parent && _vm.categoryList.parent.url
                  ? _c("ul", [
                      _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "category-nav__parent",
                            attrs: { href: _vm.categoryList.parent.url }
                          },
                          [
                            _c("span", {
                              staticClass: "icon icon-arrow-indicators"
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "Cofnij do " +
                                  _vm._s(_vm.categoryList.parent.name)
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.categoryList.children
                  ? _c("CategoryTreeList", {
                      attrs: { category: _vm.categoryList.children }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }